import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import Mainpage from './Components/Mainpage/Mainpage'
import Dashboard from './Components/Dashboard/Dashdboard'
import Pathfinding from './Components/Pathfinding/Pathfinding'
import Sorting from './Components/Sorting/Sorting'
import Searching from './Components/Searching/Searching'
function App() {
  return (
    <BrowserRouter>
        <div className="App">
          <Switch>
            <Route exact path='/'component={Mainpage} /> 
            <Route path ='/dashboard' component = {Dashboard} />
            <Route path='/pathfind' component={Pathfinding} />
            <Route path='/sort' component={Sorting} />
            <Route path='/search' component={Searching} />

          </Switch>
        </div>
      </BrowserRouter>
  );
}

export default App;
